import { render } from "./CanvasView.vue?vue&type=template&id=c6acd630"
import script from "./CanvasView.vue?vue&type=script&lang=js"
export * from "./CanvasView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/display-measurement-prd-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__